import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    getProject,
} from './../redux/actions/actions'
import { Grid, Row, Col, Button } from 'react-bootstrap/lib';
import { history } from '../redux/store';
import PropTypes from 'prop-types'
import ProjectHeader from './ProjectHeader';
import Slider from 'react-slick/lib';
import ReactCompareImage from 'react-compare-image';

const mapStateToProps = state => {
    return {
        _project: state.projects.project,
        user: state.authUser.user,
        isAuth: state.authUser.isAuth
    }
}

class Project extends Component {

    componentDidMount() {
        document.body.className = 'posts show'
    }

    componentWillMount() {
        this.props.getProject(this.props.match.params.id)
    }

    componentWillUnmount() {
        document.body.className = ''
    }

    render() {
        const { claps, title, description, technologies } = this.props._project;
        let tech;

        if (technologies) {
            tech = this.props._project.technologies.map((technologie) =>
                <div key={technologie.id} className="tech-box">
                    <img src={"/" + technologie.logo} className="project-logo" alt={technologie.name} />
                    <h4 className="title">{technologie.name}</h4>
                </div>
            );
        }

        const technologiesSliderSettings = {
            arrows: false,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 4,
            speed: 1000,
            autoplay: true,
        };
        const layersSliderSettings = {
            arrows: true,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 1,
            speed: 1000,
            autoplay: false,
        };

        return (
            <div>
                <ProjectHeader project={this.props._project} />
                <main>
                    <section className="main-section">
                        <Grid>
                            <Row>
                                <Col md={12}>
                                    {this.props.isAuth ? <Button bsStyle="primary" style={{ float: 'right' }} onClick={() => { history.push('/editor') }}>Edit</Button> : ''}
                                    <h4 className="sub-heading">Project</h4>
                                    <h1 className="heading pink"><span className="pink">{title}</span> <br /> {description}</h1>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col md={12}>
                                    <p style={{ margin: '0 10%' }}>
                                        <b>Natus Engine</b> is an advanced 3D Rendering Engine based on the DirectX 12 graphics API and written in C++ for the Microsoft Windows 10 platform. It's main features are a physically accurate material model coupled with a realistic simulation of light transport, using modern rendering techniques for real time applications.
                                    </p>
                                </Col>
                                <Col md={12}>
                                    <Slider {...layersSliderSettings}>
                                        <iframe width="920" height="518" src="https://www.youtube.com/embed/yJITcluGVPQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        <iframe width="920" height="518" src="https://www.youtube.com/embed/52LCa6zQCq8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </Slider>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col md={12}>
                                    <h4 className="sub-heading" style={{ marginBottom: '0' }}>Rendering</h4>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Physically Based Rendering</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <img className="img-box" src="../assets/pbr/pbr.png" alt="Physically Based Rendering" width="100%" />
                                    </Col>
                                    <Col md={12}>
                                        <br />
                                        <p>
                                            Physically Based Rendering (PBR) is a method of shading and rendering that
                                            provides a more accurate representation of how light interacts with surfaces.
                                            By simulating how light behaves in the real world we get more natural and
                                            believable results ensuring that materials look plausible, regardless of lighting conditions.
                                        </p>
                                        <p>
                                            The materials used in Natus Rendering Engine follow a physically based model
                                            implemented by a Standard Shader, which incorporates the advanced lighting
                                            algorithms and calculations to simulate realistic surface lighting interaction.
                                        </p>
                                        <p>
                                            The two most common workflows are metal/roughness and specular/glossiness. Natus Engine
                                            adopts the metallic workflow as originally explored by Disney and adopted for
                                            real time display by Epic Games in the Unreal Engine 4.
                                        </p>
                                    </Col>
                                    <Col md={12} style={{ textAlign: 'center' }}>
                                        <Slider {...technologiesSliderSettings}>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/brass.png" className="project-logo" alt="Brass" />
                                                <h4 className="title">Brass</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/brick.png" className="project-logo" alt="Brick" />
                                                <h4 className="title">Brick</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/brick2.png" className="project-logo" alt="Brick" />
                                                <h4 className="title">Brick</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/carpet.png" className="project-logo" alt="Carpet" />
                                                <h4 className="title">Carpet</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/coal.png" className="project-logo" alt="Coal" />
                                                <h4 className="title">Coal</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/concrete.png" className="project-logo" alt="Concrete" />
                                                <h4 className="title">Concrete</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/copper.png" className="project-logo" alt="Copper" />
                                                <h4 className="title">Copper</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/dirt.png" className="project-logo" alt="Dirt" />
                                                <h4 className="title">Dirt</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/gold.png" className="project-logo" alt="Gold" />
                                                <h4 className="title">Gold</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/gold2.png" className="project-logo" alt="Gold" />
                                                <h4 className="title">Gold</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/gold3.png" className="project-logo" alt="Gold" />
                                                <h4 className="title">Gold</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/grass.png" className="project-logo" alt="Grass" />
                                                <h4 className="title">Grass</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/leather.png" className="project-logo" alt="Leather" />
                                                <h4 className="title">Leather</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/mud.png" className="project-logo" alt="Mud" />
                                                <h4 className="title">Mud</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/mud2.png" className="project-logo" alt="Mud" />
                                                <h4 className="title">Mud</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/paint.png" className="project-logo" alt="Paint" />
                                                <h4 className="title">Paint</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/silver.png" className="project-logo" alt="Silver" />
                                                <h4 className="title">Silver</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/snow.png" className="project-logo" alt="Snow" />
                                                <h4 className="title">Snow</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/stone.png" className="project-logo" alt="Stone" />
                                                <h4 className="title">Stone</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/wall.png" className="project-logo" alt="Wall" />
                                                <h4 className="title">Wall</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/wood.png" className="project-logo" alt="Wood" />
                                                <h4 className="title">Wood</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/woodenFloor.png" className="project-logo" alt="Wooden Floor" />
                                                <h4 className="title">Wooden Floor</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/woodenFloor2.png" className="project-logo" alt="Wooden Floor" />
                                                <h4 className="title">Wooden Floor</h4>
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/pbr/woodenFloor3.png" className="project-logo" alt="Wooden Floor" />
                                                <h4 className="title">Wooden Floor</h4>
                                            </div>
                                        </Slider>
                                    </Col>
                                </Col>
                            </Row>

                            <br />

                            <Row>
                                <Col md={12}>
                                    <h4 className="sub-heading" style={{ marginBottom: '0' }}>Realtime Lighting</h4>
                                </Col>

                                <Col md={12}>
                                    <h2 className="heading pink"><span>Voxel-Based Global Illumination (VCT)</span></h2>
                                    <br />
                                    <Col md={12}>
                                        <ReactCompareImage
                                            leftImage="../assets/gi/off.png"
                                            leftImageAlt="GI OFF"
                                            rightImage="../assets/gi/on.png"
                                            rightImageAlt="GI ON"
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <br />
                                        <p>
                                            Global Illumination is the simulation of physically based light behaviour. It
                                            is a means of simulating light interaction with surfaces in a 3D Scene, which improves realism.
                                            Global Illumination algorithms take into account not only the
                                            direct light coming from light sources (direct lighting), but also the subsequent
                                            cases in which light is reflected by the scene surfaces using different materials (indirect lighting).
                                            Traditionally, indirect illumination has been to costly to
                                            compute under the real time constraints of video games.
                                        </p>
                                        <p>
                                            Crassin et al. introduced a global illumination technique known as voxel
                                            cone tracing. This technique calculates an approximation of the indirect lighting,
                                            generated by one or two bounces of light, for fully dynamic scenes in interactive
                                            applications, allowing both diffuse and glossy reflections with very realistic visual
                                            results. Instead of working on the actual geometry, a voxel representation of the
                                            scene is created and stored on the GPU.
                                        </p>
                                    </Col>
                                    <Col md={12} style={{ textAlign: 'center' }}>
                                        <img src="../assets/item-vct.png" alt="Overview of Voxel Cone Tracing" width="75%" />
                                    </Col>
                                    <Col md={12}>
                                        <br/>
                                        <p>
                                            During the first pass, known as voxelization pass, we make use of the geometry shaders to output a voxelized representation of the lighting in the original
                                            scene geometry. This is possible thanks to the GPU hardware rasterizer and a
                                            simplified version of the voxelization scheme by Crassin et al, the voxel grid is
                                            represented using a 3D Texture. The second pass, known as filtering pass, takes
                                            care of using the filtering capabilities of the GPU to create a mipmap chain. In
                                            the third pass, known as voxel cone tracing, paths are traced throughout the
                                            filtered voxel structure in order to gather and approximate the indirect lighting
                                            for a point. Each path starts at a pixel fragment position, and steps along a
                                            given direction accumulating lighting and opacity.
                                        </p>
                                    </Col>

                                </Col>
                            </Row>

                        </Grid>
                    </section>
                    <section>
                        <Grid>
                            <Row>
                                <Col md={12}>
                                    <h4 className="sub-heading">Architecture</h4>
                                    <h1 className="heading blue"><span className="blue">layered</span> engine architecture</h1>
                                </Col>
                                <Row>
                                    <Col md={12} style={{ textAlign:"center" }}>
                                        <br />
                                        <img src="../assets/engine-architecture.png" alt="Natus Engine Architecture" width="75%" />
                                    </Col>
                                    <Col md={12}>
                                        <p style={{ margin: '0px 10%' }}>
                                            <br/>
                                            A rendering engine is a complex and large software system. Like most software
                                            systems, rendering engines are built in layers. The idea is to group the different
                                            functionalities of the engine by topic and level of complexity. Normally upper
                                            layers of the system depend on the functionalities defined on the lower layers to
                                            create a more sophisticated and complex set of features. The middleware is the
                                            lowest layer of the system architecture and provides the interface to the GPU
                                            via the DirectX 12 API. On top of the middleware sits the low-level renderer,
                                            in charge of managing the drawing of primitives by communicating with the
                                            graphics API. Which contents are going to be submitted to the low-level renderer
                                            are handled by the scene graph layer. Next we have the visual effects layer,
                                            here we define all of the advanced rendering effects that our engine is capable
                                            of simulating. The top and final layer defined in our system is the front end for
                                            the 2D user interface.
                                        </p>
                                    </Col>
                                </Row>
                            </Row>
                            <Row>
                                <Col md={12} style={{ textAlign: 'center' }}>
                                    <div style={{ margin: "0 -3em" }}>
                                        <Slider {...layersSliderSettings}>
                                            <div className="tech-box">
                                                <img src="../assets/layer-middleware.png" width="100%" alt='Middleware Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-renderer.png" width="100%" alt='Low Level Renderer Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-scene.png" width="100%" alt='Scene Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-effects.png" width="100%" alt='Visual Effects Layer' />
                                            </div>
                                            <div className="tech-box">
                                                <img src="../assets/layer-frontend.png" width="100%" alt='Frontend Layer' />
                                            </div>
                                        </Slider>
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </section>
                </main>
            </div>
        );
    }
}

// Project.propTypes = {
//     params: PropTypes.object.isRequired
// }

export default connect(mapStateToProps, {
    getProject
})(Project);


// WEBPACK FOOTER //
// ./src/components/Project.js